<template>
    <ul class="pagination">
        <li class="page-item pagination-prev-nav" :class="{'disabled': isFirstPage}">
            <a class="page-link" href="/" aria-label="Previous" :tabindex="isFirstPage && -1" @click.prevent="previousPage">
                <i class="tlm-icon-chevron-left" />
            </a>
        </li>

        <li v-for="(page, key) in pageRange" :key="key" class="page-item pagination-page-nav" :class="{ 'active': page == currentPage }">
            <a class="page-link" href="/" @click.prevent="selectPage(page)">{{ page }}</a>
        </li>

        <li class="page-item pagination-next-nav" :class="{'disabled': isLastPage}">
            <a class="page-link" href="/" aria-label="Next" :tabindex="isLastPage && -1" @click.prevent="nextPage">
                <i class="tlm-icon-chevron-right" />
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        meta: {
            type: Object,
            default: _ => ({})
        },

        limit: {
            type: Number,
            default: 1
        }
    },

    computed: {
        currentPage() {
            return this.meta.current_page
        },

        lastPage() {
            return this.meta.last_page
        },

        isFirstPage() {
            return this.currentPage <= 1
        },

        isLastPage() {
            return this.currentPage >= this.lastPage
        },

        pageRange() {
            if (this.limit === -1) {
                return 0
            }

            if (this.limit === 0) {
                return this.lastPage
            }

            const left = this.currentPage - this.limit
            const right = this.currentPage + this.limit + 1
            const range = []
            const pages = []
            let l

            for (let i = 1; i <= this.lastPage; i++) {
                if (i === 1 || i === this.lastPage || (i >= left && i < right)) {
                    range.push(i)
                }
            }

            range.forEach(function (i) {
                if (l) {
                    if (i - l === 2) {
                        pages.push(l + 1)
                    } else if (i - l !== 1) {
                        pages.push('...')
                    }
                }

                pages.push(i)
                l = i
            })

            return pages
        }
    },

    methods: {
        previousPage() {
            this.selectPage(this.currentPage - 1)
        },

        nextPage() {
            this.selectPage(this.currentPage + 1)
        },

        selectPage(page) {
            if (page === '...') {
                return
            }

            this.$emit('input', page)
        }
    }
}
</script>
